// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card-module--Card--VK6eT","Shader":"Card-module--Shader--34HO4"};